import useTeacherDashboardFeatures from 'core/chatbot/hooks/useTeacherDashboardFeatures';
import { filterRoutesByFeatures } from 'core/utils/filterRoutesByFeatures';
import { privateRoutes } from './routesConfig';

import type { RouteConfig } from 'app/types/router';

/**
 * Private routes with tenant feature gating already applied.
 * Routes tagged with `feature:` in routesConfig are dropped when the
 * tenant flag is explicitly false (fail-open otherwise).
 */
export function usePrivateRoutes(): RouteConfig[] {
  const { features } = useTeacherDashboardFeatures();
  return filterRoutesByFeatures(privateRoutes, features);
}
